import { createRouter as makeRouter } from "@tanstack/react-router";
import { queryClient } from "./query-client";
import { routeTree } from "./routeTree.gen";
import { SCROLL_TO_TOP_SELECTORS } from "./lib/scroll-restoration";

export const router = makeRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadDelay: 50,
  defaultPreloadStaleTime: 0,
  defaultPendingMs: 150,
  scrollRestoration: true,
  // This app scrolls a div, not the window, so the router's built-in reset never reaches it —
  // see lib/scroll-restoration.ts.
  scrollToTopSelectors: SCROLL_TO_TOP_SELECTORS,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
